const tooltipCommentIconText="Click to submit a comment about the game.";
export default tooltipCommentIconText;